// @flow
import React from 'react';
import cx from 'classnames';

import './FakeProductCard.scss';
import Productpone from '../Productpone/Productpone';
import GrayBoxes from "../GrayBoxes";
import GrayBox from "../GrayBox";

type Props = {
  oneColumn?: boolean,
  isTrending?: boolean,
};

const FakeProductCard = ({ oneColumn, isTrending }: Props) => (
  <Productpone duration={100}>
    <div
      className={cx('ProductCard FakeProductCard', { 'one-column': oneColumn, mobile: isTrending })}
    >
      <div className="thumbnail-wrapper">
        <img src="https://images.cacheby.com/placeholder.png?s=600x316&t=crop&q=82&f=webp" alt="thumbnail" />
      </div>
      <div className="card-content">
        {/* {!oneColumn && <div className="user-thumbnail-wrapper" />} */}
        <div className="content-head">
          <div className="username">
            <GrayBox min={2} max={5} />
          </div>
          <div className="title">
            <GrayBoxes countMin={3} countMax={5} sizeMin={2} sizeMax={4} />
          </div>
          <div className="price">
            <GrayBox min={5} max={5} />
          </div>
          <div className="subinfo">
            <GrayBox min={3} max={5} />
          </div>
        </div>
      </div>
    </div>
  </Productpone>
);

FakeProductCard.defaultProps = {
  oneColumn: false,
};

export default FakeProductCard;



// WEBPACK FOOTER //
// ./src/components/common/FakeProductCard/FakeProductCard.js